import {
  FilterOperation,
  GlobalSearchItemType,
  GlobalSearchProperty,
  useUpmGlobalSearch
} from '@domain/upm'
import {useMemo} from 'react'

type UseDepartmentNameMapParams = {
  departmentUpmIds: string[]
  isEnabled: boolean
}

export const useDepartmentNameMap = ({departmentUpmIds, isEnabled}: UseDepartmentNameMapParams) => {
  const {data: departmentSearchData} = useUpmGlobalSearch(
    {
      pageSize: departmentUpmIds.length,
      pageNumber: 1,
      filters: [
        {
          property: GlobalSearchProperty.DepartmentUpmId,
          operation: FilterOperation.In,
          values: departmentUpmIds
        }
      ],
      itemTypes: [GlobalSearchItemType.Department]
    },
    {
      enabled: isEnabled && !!departmentUpmIds.length
    }
  )

  return useMemo(() => {
    const map = new Map<string, string>()
    if (departmentSearchData?.items) {
      departmentSearchData.items.forEach((item) => {
        if (item.itemType === GlobalSearchItemType.Department) {
          map.set(item.upmId, item.displayValue || item.upmId)
        }
      })
    }
    return map
  }, [departmentSearchData])
}
